/* ============================================================
   <product-pack> — Spend & Save tier picker
   Multi-pack pricing UI for Zea PDPs (Vue 2 compatible)
   ============================================================ */
(function () {
  'use strict';

  if (window.customElements && customElements.get('product-pack')) return;

  function formatDollars(cents) {
    if (cents == null || isNaN(cents)) return '0.00';
    return (cents / 100).toFixed(2);
  }

  class ProductPack extends HTMLElement {
    constructor() {
      super();
      this._onChange = this._onChange.bind(this);
    }

    connectedCallback() {
      this._formEl = this.closest('#product-form') || document.getElementById('product-form');
      this._vue = null;
      this._basePriceCents = parseInt(this.getAttribute('data-base-price-cents'), 10) || null;
      this._baseCompareCents = parseInt(this.getAttribute('data-base-compare-cents'), 10) || null;
      this._variantWatcher = null;

      // Variants where picker should be hidden (variant.metafields.custom.pack_picker == false)
      var hiddenStr = this.getAttribute('data-hidden-variants') || '';
      this._hiddenVariantIds = {};
      hiddenStr.split(',').forEach(function (id) {
        var t = id.trim();
        if (t) this._hiddenVariantIds[t] = true;
      }, this);

      this.addEventListener('change', this._onChange);
      this._waitForVue(20);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this._onChange);
      if (this._variantWatcher) try { this._variantWatcher(); } catch (e) {}
    }

    _waitForVue(attemptsLeft) {
      if (!this._formEl) return;
      var vue = this._formEl.__vue__;
      if (vue && typeof vue.quantity !== 'undefined') {
        this._vue = vue;
        this._wireVariantWatch();
        var v = vue.current_variant || {};
        var price = (v.price != null) ? Number(v.price) : this._basePriceCents;
        var compare = (v.compare_at_price != null) ? Number(v.compare_at_price) : this._baseCompareCents;
        this._updateVisibility(v.id);
        this._renderPrices(price, compare);
        this._applyDefault();
        return;
      }
      if (attemptsLeft <= 0) return;
      var self = this;
      setTimeout(function () { self._waitForVue(attemptsLeft - 1); }, 150);
    }

    _updateVisibility(variantId) {
      if (variantId == null) return;
      var hidden = !!this._hiddenVariantIds[String(variantId)];
      this.style.display = hidden ? 'none' : '';
    }

    _wireVariantWatch() {
      if (!this._vue || typeof this._vue.$watch !== 'function') return;
      var self = this;
      this._variantWatcher = this._vue.$watch('current_variant', function (newV) {
        if (!newV) return;
        var price = newV.price != null ? Number(newV.price) : self._basePriceCents;
        var compare = newV.compare_at_price != null ? Number(newV.compare_at_price) : self._baseCompareCents;
        self._updateVisibility(newV.id);
        self._renderPrices(price, compare);
      }, { deep: false });
    }

    _renderPrices(priceCents, compareCents) {
      if (priceCents == null || isNaN(priceCents)) return;
      var hasSale = compareCents != null && !isNaN(compareCents) && compareCents > priceCents;

      var amountEls = this.querySelectorAll('.spend-save__unit-price');
      for (var i = 0; i < amountEls.length; i++) {
        var pct = parseFloat(amountEls[i].getAttribute('data-tier-pct')) || 0;
        var unitCents = priceCents * (100 - pct) / 100;
        var amountEl = amountEls[i].querySelector('.spend-save__unit-amount');
        if (amountEl) amountEl.textContent = formatDollars(unitCents);
      }

      var saveEls = this.querySelectorAll('.spend-save__save');
      for (var j = 0; j < saveEls.length; j++) {
        var saveEl = saveEls[j];
        var tierPct = parseFloat(saveEl.getAttribute('data-tier-pct')) || 0;
        var unitCents = priceCents * (100 - tierPct) / 100;
        var displayPct = 0;
        if (hasSale) {
          displayPct = Math.round((compareCents - unitCents) / compareCents * 100);
        } else {
          displayPct = Math.round(tierPct);
        }
        if (displayPct > 0) {
          saveEl.hidden = false;
          var pctEl = saveEl.querySelector('.spend-save__save-pct');
          if (pctEl) pctEl.textContent = displayPct;
        } else {
          saveEl.hidden = true;
        }
      }

      // Variant changed — re-render the buy-box pack-total display (waits for Vue's render).
      this._renderBuyboxPrice();
      // And re-sync Loop's subscription group to match the new variant.
      this._syncLoopGroupToVariant();
    }

    _ensureBuyboxBundleEl() {
      if (this._buyboxBundleEl && document.body.contains(this._buyboxBundleEl)) {
        return this._buyboxBundleEl;
      }
      var form = this._formEl;
      if (!form) return null;
      var orig = form.querySelector('.aproduct-price');
      if (!orig || !orig.parentNode) return null;

      var bundle = document.createElement('div');
      bundle.className = 'aproduct-price-bundle text-brand mb-3';
      bundle.setAttribute('aria-live', 'polite');
      bundle.style.display = 'none';
      orig.parentNode.insertBefore(bundle, orig.nextSibling);
      this._origPriceEl = orig;
      this._buyboxBundleEl = bundle;
      return bundle;
    }

    _renderBuyboxPrice() {
      if (!this._vue || typeof this._vue.$nextTick !== 'function') {
        this._writeBuyboxPrice();
        return;
      }
      var self = this;
      this._vue.$nextTick(function () { self._writeBuyboxPrice(); });
    }

    _writeBuyboxPrice() {
      var bundle = this._ensureBuyboxBundleEl();
      if (!bundle) return;

      var checked = this.querySelector('input[type="radio"]:checked');
      var qty = 1;
      var pct = 0;
      if (checked) {
        var q = parseInt(checked.getAttribute('data-qty'), 10);
        if (!isNaN(q) && q >= 1) qty = q;
        pct = parseFloat(checked.getAttribute('data-discount-pct')) || 0;
      }

      var v = (this._vue && this._vue.current_variant) || {};
      var unitCents = (v.price != null) ? Number(v.price) : this._basePriceCents;
      var unitCompareCents = (v.compare_at_price != null && Number(v.compare_at_price) > 0)
        ? Number(v.compare_at_price)
        : null;
      if (unitCents == null || isNaN(unitCents)) return;

      if (qty <= 1) {
        bundle.style.display = 'none';
        if (this._origPriceEl) this._origPriceEl.style.display = '';
        return;
      }

      var totalCents = Math.round(unitCents * qty * (100 - pct) / 100);
      var hasSale = unitCompareCents != null && unitCompareCents > unitCents;
      var rrpCents = hasSale ? (unitCompareCents * qty) : (unitCents * qty);
      var saveCents = rrpCents - totalCents;

      var html = '';
      if (saveCents > 0) {
        html += '<s class="aproduct-price-bundle__rrp">$' + formatDollars(rrpCents) + '</s> ';
      }
      html += '<span class="text-brand colorChange aproduct-price-bundle__total">$' + formatDollars(totalCents) + '</span>';

      bundle.innerHTML = html;
      bundle.style.display = '';
      if (this._origPriceEl) this._origPriceEl.style.display = 'none';
    }

    _applyDefault() {
      var checked = this.querySelector('input[type="radio"]:checked');
      if (checked) this._applyTier(checked);
    }

    _onChange(e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      this._applyTier(t);
    }

    _applyTier(radio) {
      var qty = parseInt(radio.getAttribute('data-qty'), 10);
      if (isNaN(qty) || qty < 1) qty = 1;
      var pct = parseFloat(radio.getAttribute('data-discount-pct')) || 0;

      if (this._vue) {
        this._vue.quantity = qty;
      } else {
        var qtyInput = (this._formEl || document).querySelector('input[name="quantity"]');
        if (qtyInput) {
          qtyInput.value = String(qty);
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      this._syncLoopOneTimePrice(pct);
      this._syncLoopVisibility(qty);
      this._renderBuyboxPrice();

      this.dispatchEvent(new CustomEvent('product-pack:change', {
        bubbles: true,
        detail: { qty: qty, discountPct: pct }
      }));
    }

    _syncLoopVisibility(qty) {
      // Hide the Loop Subscribe & Save container (fieldset + "Subscription details"
      // tooltip) when a multi-pack tier (qty > 1) is selected — pack bundles don't
      // pair with a subscription.
      // Force the "One Time Purchase" radio checked first so the cart submits as a
      // one-time bundle purchase, not a subscription.
      var fset = document.getElementById('loop-selling-plan-fieldset');
      var container = document.querySelector('[id^="loop-subscription-container-"]');
      if (!fset && !container) return;
      if (qty > 1) {
        if (fset) {
          var oneTimeRadio = fset.querySelector('.loop-one-time-purchase-option input[type="radio"]');
          if (oneTimeRadio && !oneTimeRadio.checked) {
            oneTimeRadio.checked = true;
            oneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (container) container.style.display = 'none';
        else if (fset) fset.style.display = 'none';
      } else {
        if (container) container.style.display = '';
        if (fset) fset.style.display = '';
        // When revealing, make sure Loop is showing the subscription group that
        // matches the currently-selected size variant. Loop's own variant sync
        // can race with the theme's load-time workaround and end up locked on
        // the wrong variant (e.g. 50g $19.51 instead of 100g $29.71).
        this._syncLoopGroupToVariant();
      }
    }

    _syncLoopGroupToVariant() {
      // Force Loop's per-variant subscription UI to reflect the currently selected
      // variant. Loop wraps each variant's subscription options in:
      //   <div id="loop-product-variant-{variantId}">…</div>
      // and toggles display on those wrappers. If Loop's own variant sync races
      // with the theme's load-time workaround, the wrong wrapper can stay visible
      // (e.g. 50g $19.51 shows when 100g is actually selected).
      //
      // Belt and braces: enforce the wrapper-level scoping AND the
      // `.loop-subscription-group` class-level scoping so a stale state can't
      // sneak through.
      var variantId = (this._vue && this._vue.current_variant && this._vue.current_variant.id != null)
        ? String(this._vue.current_variant.id)
        : null;
      if (!variantId) return;

      // 1. Wrapper level — Loop's primary variant-scoping mechanism.
      var wrappers = document.querySelectorAll('[id^="loop-product-variant-"]');
      for (var w = 0; w < wrappers.length; w++) {
        var wrap = wrappers[w];
        var wm = wrap.id.match(/^loop-product-variant-(\d+)$/);
        var wVid = wm ? wm[1] : null;
        if (wVid && wVid === variantId) {
          wrap.style.display = '';
        } else if (wVid) {
          wrap.style.display = 'none';
        }
      }

      // 2. Class level — `.loop-subscription-group` elements have their own
      //    `loop-display-none` toggle. Match on the inner price element's id
      //    (`loop-price-<variantId>-<sellingPlanGroupId>`).
      var groups = document.querySelectorAll('.loop-subscription-group');
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        var priceEl = g.querySelector('[id^="loop-price-"]');
        var idAttr = priceEl ? priceEl.id : '';
        var m = idAttr.match(/^loop-price-(\d+)-/);
        var groupVariantId = m ? m[1] : null;
        if (groupVariantId === variantId) {
          g.classList.remove('loop-display-none');
        } else if (groupVariantId) {
          g.classList.add('loop-display-none');
        }
      }
    }

    _syncLoopOneTimePrice(pct) {
      // Keep Loop's "One Time Purchase" price label aligned with picker tier.
      // Subscribe row is intentionally NOT updated — it stays at RRP × (1 - subscription %),
      // independent of the picker, so subscription doesn't visually stack with Spend & Save.
      var basePrice = (this._vue && this._vue.current_variant && this._vue.current_variant.price != null)
        ? Number(this._vue.current_variant.price)
        : this._basePriceCents;
      if (basePrice == null || isNaN(basePrice)) return;
      var unitCents = basePrice * (100 - pct) / 100;
      var unit = '$' + formatDollars(unitCents);
      var nodes = document.querySelectorAll('#loop-price-one-time, #loop-price-one-time-original');
      for (var i = 0; i < nodes.length; i++) nodes[i].textContent = unit;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (!customElements.get('product-pack')) customElements.define('product-pack', ProductPack);
    });
  } else {
    customElements.define('product-pack', ProductPack);
  }
})();

